import React from 'react';
import { Facebook, Instagram, YouTube } from '@mui/icons-material';
import { FaSoundcloud, FaTiktok } from 'react-icons/fa';
import { SocialIconsContainer, StyledIconButton } from '../../styles/Navigation/Footer.style';
import { MobileStyledFooterBox } from '../../styles/MOBILE/MobileStyles';
import { SocialMediaLinks } from '../../enums/page_texts/homepage_texts';

const MobileFooter: React.FC = () => {

  const handleRedirect = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <MobileStyledFooterBox>
      <SocialIconsContainer>
        <StyledIconButton onClick={() => handleRedirect(SocialMediaLinks.Facebook)}>
          <Facebook />
        </StyledIconButton>
        <StyledIconButton onClick={() => handleRedirect(SocialMediaLinks.SoundCloud)}>
          <FaSoundcloud />
        </StyledIconButton>
        <StyledIconButton onClick={() => handleRedirect(SocialMediaLinks.Instagram)}>
          <Instagram />
        </StyledIconButton>
        <StyledIconButton onClick={() => handleRedirect(SocialMediaLinks.YouTube)}>
          <YouTube />
        </StyledIconButton>
        <StyledIconButton onClick={() => handleRedirect(SocialMediaLinks.TikTok)}>
          <FaTiktok />
        </StyledIconButton>
      </SocialIconsContainer>
    </MobileStyledFooterBox>
  );
};

export default MobileFooter;
